import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  LISTING_SERVICE_TYPE_SUNRISE,
} from 'common/listingConstants';

import {
  MARKETING_PARTNER_LISTING_STATUS_IN_PROGRESS,
} from 'common/marketingPartnerListingConstants';

import {
  DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
} from 'common/dataTableConstants';

import SrText from 'client/components/SrText';
import SrPartnerSection from 'client/components/SrPartnerSection';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrGoingToMarketSunRiseListingCard from 'client/components/SrGoingToMarketSunRiseListingCard';
import SrListingEditWalkThroughFieldsModal from 'client/components/SrListingEditWalkThroughFieldsModal';
import SrPartnerMarketListingEditDueDateModal from 'client/components/SrPartnerMarketListingEditDueDateModal';
import useBranch from 'client/hooks/useBranch';
import { USER_ROLE_ADMIN } from 'common/userRoles';

const SrDataTableSetupInProgressPartnerListings = ({
  partner,
  dispatch,
  reloadDataTableMarketingPartnerListing,
}) => {

  const {
    currentUser,
  } = useBranch({
    currentUser: ['currentUser'],
  });

  const [
    listingEditWalkThroughFieldsModal,
    setListingEditWalkThroughFieldsModal,
  ] = useState(null);

  const [
    editDueDateModalProps,
    setEditDueDateModalProps,
  ] = useState(null);

  if (partner == null) return null;

  const dataTableSettings = {
    itemsPropName: 'marketingListings',
    dataSource: DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
    rootViewId: DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
    count: 30,
    initialViewSettings: {
      viewId: DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
      loadAllData: true,
      filter: {
        'marketingPartnerListings.status': MARKETING_PARTNER_LISTING_STATUS_IN_PROGRESS,
        'listings.partnerId': partner.id,
      },
      customParams: {
        partnerListings: {
          serviceType: LISTING_SERVICE_TYPE_SUNRISE,
        },
      },
    },
  };

  const isAdmin = currentUser.roles.includes(USER_ROLE_ADMIN);

  return (
    <SrDataTableConnected {...dataTableSettings}>
      {({ marketingListings, dataTableApiState, dataTableIsFullyLoaded, reloadItems }) => {
        const noItems = dataTableIsFullyLoaded && marketingListings.length === 0;

        return (
          <div className='SrDataTableMarketingPartnerListings'>
            <SrPartnerSection
              title='Setups in Progress'
            >
              {noItems && (
                <SrText font='greycliff' weight='600' color='grey' fontSize='16px'>
                  All setups have been completed!
                </SrText>
              )}
              <div className='listings'>
                {marketingListings.map((listing) => {
                  return (
                    <div key={`setup-in-progress-${listing.id}`}>
                      <SrGoingToMarketSunRiseListingCard
                        isAdmin={isAdmin}
                        marketingListing={listing}
                        onEditWalkThroughFields={
                          () => setListingEditWalkThroughFieldsModal(listing)
                        }
                        onEditMarketingPartnerListingDueDate={
                          () => setEditDueDateModalProps(listing)
                        }
                        reloadData={() => reloadItems({
                          count: 1,
                          filter: { 'marketingPartnerListings.id': listing.id },
                        })}
                      />
                    </div>
                  );
                })}
              </div>
              {dataTableApiState.inProgress && (
                <div className='loading-ellipses' />
              )}
            </SrPartnerSection>
            {listingEditWalkThroughFieldsModal && (
              <SrListingEditWalkThroughFieldsModal
                marketingPartnerListing={listingEditWalkThroughFieldsModal}
                listingId={listingEditWalkThroughFieldsModal.listingId}
                dispatch={dispatch}
                onClose={() => setListingEditWalkThroughFieldsModal(null)}
                reloadDataTableMarketingPartnerListing={reloadDataTableMarketingPartnerListing}
              />
            )}
            {editDueDateModalProps && (
              <SrPartnerMarketListingEditDueDateModal
                marketingPartnerListing={editDueDateModalProps}
                dispatch={dispatch}
                reloadDataTableMarketingPartnerListing={reloadDataTableMarketingPartnerListing}
                onClose={() => setEditDueDateModalProps(null)}
              />
            )}
          </div>
        );
      }}
    </SrDataTableConnected>
  );

};

SrDataTableSetupInProgressPartnerListings.propTypes = {
  partner: PropTypes.object,
  dispatch: PropTypes.func,
  reloadDataTableMarketingPartnerListing: PropTypes.func,
};

SrDataTableSetupInProgressPartnerListings.displayName = 'SrDataTableSetupInProgressPartnerListings';

export default SrDataTableSetupInProgressPartnerListings;
